module.exports = __webpack_public_path__ + "img/cart.f0bf91f3.svg";